import { useWeb3React } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { InjectedConnector } from '@web3-react/injected-connector'
import { ResetCSS } from '@farmersonly/uikit'
import BigNumber from 'bignumber.js'
import React, { lazy, Suspense, useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { useFetchPublicData } from 'state/hooks'
import PageLoader from './components/PageLoader'
import 'bootstrap/dist/css/bootstrap.min.css'
import GlobalStyle from './style/Global'

const Pools = lazy(() => import('./views/Pools'))
const NotFound = lazy(() => import('./views/NotFound'))

// This config is required for number formating
BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

const App: React.FC = () => {
  const { activate } = useWeb3React<Web3Provider>()
  useEffect(() => {
    const account = async () => {
      if (window.ethereum) {
        const foundAccount = await window.ethereum.request({ method: 'eth_requestAccounts' })
        if (foundAccount) {
          const injectedConnector = new InjectedConnector({ supportedChainIds: [43113, 43114] })
          activate(injectedConnector)
        }
      }
    }
    account()
  })

  useFetchPublicData()

  return (
    <Router>
      <ResetCSS />
      <GlobalStyle />
      <Suspense fallback={<PageLoader />}>
        <Switch>
          <Pools />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </Router>
  )
}

export default React.memo(App)
